moment = require('moment')

module.exports = (
  $uibModalInstance,
  $scope,
  publishedDate
) ->
  $scope.model =
    publishedDate: if publishedDate then moment(publishedDate).toDate() else null

  $scope.submit = () ->
    $scope.submitted = true
    if $scope.forms.form.$valid
      formattedPublishedDate = if $scope.model.publishedDate then moment($scope.model.publishedDate).format('YYYY-MM-DD') else null
      $uibModalInstance.close(formattedPublishedDate)

  $scope.cancel = () ->
    $uibModalInstance.dismiss()
